import { combineReducers } from "redux";
import createClass from "./createClass";
import classDetails from "./classDetails";
import auth from "../auth/authReducer";
import instructorsEmails from "./instructorsEmails";
import book from "./book";
import books from "./books";
import updateClassInfo from "./updateClassInfo";
import instructorRequest from "./acceptInvite";
import classInfoById from "./classInfoById";
import sectionUpdate from "./sectionUpdate";
import student from "./student";
import bookFelids from "./bookFeilds";
import studentBlanks from "./studentBlanks";
import dashboard from "./dashboard";
import activityQuestions from "./activityQuestions";
export default combineReducers({
  classes: createClass,
  classDetails: classDetails,
  updateClassInfo: updateClassInfo,
  instructors: instructorsEmails,
  acceptInvite: instructorRequest,
  auth: auth,
  book,
  books,
  classInfoById: classInfoById,
  sectionUpdate: sectionUpdate,
  student,
  bookFelids: bookFelids,
  activityQuestions: activityQuestions,
  studentBlanks,
  dashboard,
});
